import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import actions from "../../../Redux/Action";
import Helmet from "@Core/Components/Helmet";
import Breadcrumbs from '@Core/Components/Breadcrumbs';
import ProductSearchContainer from 'Pages/CommnPages/ProductSearchContainer'
import './css/extendedHoursSC.css'
import ExtendedHoursSCSearch from './Components/ExtendedHoursSCSearch';
import ExtendedHoursSCList from './Components/ExtendedHoursSCList';
import { useJsApiLoader } from '@react-google-maps/api';
import Cookies from 'js-cookie'
const ExtendedHours = (props) => {
    const history = useHistory();
    const dispatch = useDispatch()
    let locationCookie = Cookies.get('location')
    const [location, setLocation] = useState({
        loaded: false,
        coordinates: { lat: "", long: "" },
    });
    let MetaTag = useSelector((state) => state.productReducer.GetMetaTag) || []
    let ExtendedHourSCData = useSelector((state) => state.ServiceReducer.ExtendedHourSCData) || {};
    let SellerList = useSelector((state) => state.ServiceReducer.SVCExtendedWorkingHours) || [];
    const [filterSaller, setFilterSaller] = useState(SellerList)
    const [selectedServices, setSelectedServices] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    let metaData = MetaTag && MetaTag.length > 0 && MetaTag.filter(item => item.PageName == process.env.REACT_APP_MATATAG_EXTENDED_HOURS).length ? MetaTag.filter(item => item.PageName == process.env.REACT_APP_MATATAG_EXTENDED_HOURS) : []

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
    })
    useEffect(() => {
        if (!("geolocation" in navigator)) {
            onError({
                code: 0,
                message: "Geolocation not supported",
            });
        }
        navigator.geolocation.getCurrentPosition(onSuccess, onError);
    }, [allow]);
    const [allow, setAllow] = useState(false)

    useEffect(() => {
        props.handleLogging('', { ChildMenuRedirectURL: process.env.REACT_APP_EXTENDED_HOURS_ROUTE, ChildMenuName: "Samsung Extended Hours Service Centers", ChildMenuTitle: "Extended Hours Service Centers", ChildCatogoryCode: "Extended Hours Service Centers" }, 1, "Samsung Extended Hours Service Centers")
    }, [])
    const onSuccess = (location) => {
        let data = {
            loaded: true,
            coordinates: {
                lat: location.coords.latitude,
                long: location.coords.longitude,
            },
            error: {}
        }
        handleExtendedHourSCData('', '', { lat: location.coords.latitude, long: location.coords.longitude })
        Cookies.set('location', true)
        setLocation(data);
    };

    const onError = (error) => {
        let data = {
            loaded: true,
            error: {
                code: error.code,
                message: error.message,
            },
        }
        handleExtendedHourSCData('', '', { lat: '', long: '', })
        Cookies.set('location', true)
        setLocation(data);
    };

    const handleExtendedHourSCData = (name, value, multiData = {}) => {
        let data = {}
        //delete SpareRepaireData.error[name]
        if (multiData && Object.keys(multiData).length) {
            data = { ...ExtendedHourSCData, ...multiData }
        } else data = { ...ExtendedHourSCData, [name]: value }

        dispatch(actions.ServiceAction.SetExtendedHourSCData(data))
    }

    const handleRequestService = (e) => {
        e.preventDefault();
        props.handleIntExtRoute(e, { 'sourceName': "Quick Links", 'ChildMenuName': "RequestService", 'ChildMenuTitle': "Request Service", 'ChildMenuRedirectURL': process.env.REACT_APP_REQUESTSERVICE, 'ChildMenuType': '2' });
        props.handleLogging(e, { ChildMenuRedirectURL: process.env.REACT_APP_REQUESTSERVICE, ChildMenuName: 'requestService' }, 1, 'Self Help Request Service')
    }

    const getProductServiceName = (productCategory) => {
        let data = [
            { 'product': 'Air Conditioner', 'code': 'AC' },
            { 'product': 'Washing Machine', 'code': 'WM' },
            { 'product': 'Refrigerator', 'code': 'REF' }
        ];

        let ProductServiceName = productCategory && productCategory.length && data && data.map(item => { if (productCategory.includes(item.code)) return (item.product) }).filter(item => item).join(', ')
        return ProductServiceName || ''
    }
    console.log(ExtendedHourSCData, 'ExtendedHourSCData')
    return (
        <>
            <Helmet title={metaData && metaData.length && metaData[0].PageTitle || process.env.REACT_APP_MATATAG_TITLE_EXTENDED_HOURS} data={metaData} defaultName={process.env.REACT_APP_MATATAG_NAME} defaultContent={process.env.REACT_APP_MATATAG_CONTENT_EXTENDED_HOURS} />
            <div className="extended-hrs">
                <div className="spare-parts--Comp">
                    <div className="other-products">
                        <div className="search-product-card">
                            <section className="offer-header margin-top--none margin-bottom--none ">
                                <div className="offer-header__container">
                                    <div className="offer-header__wrapper">
                                        <div className="offer-header__slide bg-white">
                                            <div className="offer-header__slide-inner">
                                                <div className="offer-header__background-media-wrap">
                                                    <div className="image image--dyn-height image--main-loaded">
                                                        {/* <img className="image__preview responsive-img image--loaded image--hide" alt="Furrget us not!" src="img/optin/banner_img_m.png" aria-hidden="true" /> */}
                                                        <img className="image__main responsive-img image--loaded" alt="Furrget us not!" src={props.isMobile ? `img/extended/extendedBanner.png` : `img/extended/extendedBanner.png`} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section >
                            <section className="optsection1 pt-3 pb-3 px-3">
                                <p class="color-5b font-600" data-font-size-pc="16" data-font-size-mo="14">
                                    We know your time is valuable, and mobile repairs shouldn’t have to wait. That’s why our Service Centres are now open with extended hours*, till 10 PM every day. Whether it’s a busy workday or a packed schedule, you no longer need to skip office or rearrange your day for a repair. Simply walk in after work, at a time that suits you best. Our expert team is ready to assist with quick, reliable service whenever you need it. Visit us today, at your convenience.
                                </p>
                                <p class="font-700 mt-3" data-font-size-pc="16" data-font-size-mo="14">
                                    *Extended hours service is currently available in selected service centers only.
                                </p>
                            </section>
                            <section className="optsection1 mt-5 mb-5">
                                <div className="text-center">
                                    <h2 className="others-card__title  desktop-text-align--center mobile-text-align--center  mb-5 mt-sm-4 mt-md-5" data-font-size-mo="20" data-font-size-pc="38">Find a Service Center</h2>
                                    {/* <p className="card__description desktop-text-align--center mobile-text-align--center mb-2 mb-md-5" data-font-size-mo="12" data-font-size-pc="14">Easy access to service information</p> */}
                                </div>
                            </section>
                            <ExtendedHoursSCSearch {...props} ExtendedHourSCData={ExtendedHourSCData} handleExtendedHourSCData={handleExtendedHourSCData} setFilterSaller={setFilterSaller} filterSaller={filterSaller} setSelectedServices={setSelectedServices} selectedServices={selectedServices} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} />

                            {SellerList.length === 0 ?
                                <div className="other-products-bx mt-4">
                                    <div className='no-product-box'>
                                        <img src='img/spareparts/no-product-img.svg' className=' img-responsive' alt='no-product' />
                                        <h3 data-font-size-mo="20" data-font-size-pc="32" className="mt-4 mb-3 others-card__title-font text-muted">Samsung Extended Hours Service Centers</h3>
                                    </div>
                                </div>
                                :
                                <ExtendedHoursSCList {...props} ExtendedHourSCData={ExtendedHourSCData} handleExtendedHourSCData={handleExtendedHourSCData} SellerList={SellerList} setFilterSaller={setFilterSaller} filterSaller={filterSaller} setSelectedServices={setSelectedServices} selectedServices={selectedServices} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} getProductServiceName={getProductServiceName} />
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExtendedHours